<template>
<div>
  <div class="section grey">
    <div class="ui container">
      <h1 class="ui header">Founding Team</h1>
      <div class="ui hidden divider"></div>
      <div class="ui hidden divider"></div>
      <div class="ui very relaxed very padded stackable grid">
        <div class="four wide column">
          <img class="ui middle aligned circular image" src="https://aragon.one/rsc/imgs/about/luis.jpg">
        </div>
        <div class="twelve wide column">
          <h2>Luis Cuende - Project Lead</h2>
          <p>Luis has been awarded as the best underage European programmer in 2011, is a Forbes 30 Under 30, a MIT TR35 and was an Advisor to the VP of the European Commission.</p>
          <p>He cofounded the blockchain startup <a href="https://stampery.com" target="_blank" rel="noopener">Stampery</a>. Prior to founding startups, he created the world's first Linux distribution with facelogin.</p>
          <a href="https://blog.aragon.one/team-interviews-luis-aragons-project-lead-c4916bb3cfb4" target="_blank" rel="noopener" class="aragon underline green text"><i class="ui medium icon"></i>Interview</a>
          <span style="display:inline-block; width: 1rem;"></span>
          <a href="https://twitter.com/licuende" target="_blank" rel="noopener" class="aragon underline blue text"><i class="ui twitter icon"></i>licuende</a>
          <span style="display:inline-block; width: 1rem;"></span>
          <a href="https://github.com/luisivan" target="_blank" rel="noopener" class="aragon underline grey text"><i class="ui github icon"></i>luisivan</a>
        </div>
      </div>
      <div class="ui hidden divider"></div>
      <div class="ui hidden divider"></div>
      <div class="ui very relaxed very padded stackable grid">
        <div class="four wide column">
          <img class="ui middle aligned circular image" src="https://aragon.one/rsc/imgs/about/jorge.jpg">
        </div>
        <div class="twelve wide column">
          <h2>Jorge Izquierdo - Tech Lead</h2>
          <p>Curious hacker, creator of multiple apps for iOS, macOS and Pebble. Reached App Store's #2. Always tinkering with new tech.</p>
          <p>Already convinced about the decentralized future of the Internet, he has been building toy projects such as a <a target="_blank" href="http://github.com/izqui/net" rel="noopener">mesh network</a> or a small <a target="_blank" href="http://github.com/izqui/blockchain" rel="noopener">blockchain implementation</a> since 2014.</p>
          <a href="https://blog.aragon.one/team-interviews-jorge-aragons-tech-lead-dae54d7eacac" target="_blank" rel="noopener" class="aragon underline green text"><i class="ui medium icon"></i>Interview</a>
          <span style="display:inline-block; width: 1rem;"></span>
          <a href="https://twitter.com/izqui9" target="_blank" rel="noopener" class="aragon underline blue text"><i class="ui twitter icon"></i>izqui9</a>
          <span style="display:inline-block; width: 1rem;"></span>
          <a href="https://github.com/izqui" target="_blank" rel="noopener" class="aragon underline grey text"><i class="ui github icon"></i>izqui</a>
        </div>
      </div>
    </div>
  </div>
  <div class="section">
    <div class="ui container">
      <h1 class="ui header">Partners</h1>
      <div class="ui hidden divider"></div>
      <div class="ui hidden divider"></div>
      <div class="ui very relaxed very padded stackable center aligned equal width grid">
        <div class="middle aligned column">
          <a href="https://coinfund.io" target="_blank"><img class="ui middle aligned image" src="https://aragon.one/rsc/imgs/partners/coinfund.png"></a>
        </div>
        <div class="middle aligned column">
          <a href="https://iconomi.net" target="_blank"><img class="ui middle aligned image" src="https://aragon.one/rsc/imgs/partners/iconomi.png"></a>
        </div>
        <div class="middle aligned column">
          <a href="https://shapeshift.io" target="_blank"><img class="ui middle aligned image" src="https://aragon.one/rsc/imgs/partners/shapeshift.png"></a>
        </div>
        <div class="middle aligned column">
          <a href="http://boost.vc" target="_blank"><img class="ui middle aligned image" src="https://aragon.one/rsc/imgs/partners/boost.png"></a>
        </div>
        <div class="middle aligned column">
          <a href="http://wachsmanpr.com" target="_blank"><img class="ui middle aligned image" src="https://aragon.one/rsc/imgs/partners/wachsman.png"></a>
        </div>
        <div class="middle aligned column">
          <a href="http://www.novakrutar.si/en/" target="_blank"><img class="ui middle aligned image" src="https://aragon.one/rsc/imgs/partners/novakrutar.png"></a>
        </div>
      </div>
    </div>
  </div>
  <div class="section grey">
    <div class="ui container">
      <h1 class="ui header">Advisors</h1>
      <div class="ui hidden divider"></div>
      <div class="ui hidden divider"></div>
      <div class="ui very relaxed very padded stackable grid">
        <div class="four wide column">
          <img class="ui middle aligned circular image" src="https://aragon.one/rsc/imgs/about/jake.jpg">
        </div>
        <div class="twelve wide column">
          <h2>Jake Brukhman - Cofounder at CoinFund</h2>
          <p>Cofounder of <a href="http://coinfund.io" target="_blank" rel="noopener">CoinFund</a>, a blockchain research company and private investment vehicle. Previously Partner &amp; CTO at Triton Research, technical product manager and engineer at Amazon.com, and spent 5 years in financial technology in New York City.</p>
          <p>Technologist with a background in mathematics, computer science, distributed systems, web development, product management, private equity research, and startups.</p>
          <a href="https://twitter.com/jbrukh" target="_blank" rel="noopener" class="aragon underline blue text"><i class="ui twitter icon"></i>jbrukh</a>
          <span style="display:inline-block; width: 1rem;"></span>
          <a href="https://github.com/jbrukh" target="_blank" rel="noopener" class="aragon underline grey text"><i class="ui github icon"></i>jbrukh</a>
        </div>
      </div>
      <div class="ui hidden divider"></div>
      <div class="ui hidden divider"></div>
      <div class="ui very relaxed very padded stackable grid">
        <div class="four wide column">
          <img class="ui middle aligned circular image" src="https://aragon.one/rsc/imgs/about/kenny.jpg">
        </div>
        <div class="twelve wide column">
          <h2>Kenny Rowe - COO of Dai Foundation</h2>
          <p>COO of Dai Foundation for <a target="_blank" href="https://makerdao.com" rel="noopener">Maker DAO</a>, seeking to minimize the price volatility of its own stable token — the Dai — against the IMF’s international currency basket SDR.</p>
          <p>Founder of OnChain consulting. Seattle Ethereum Meetup organizer. Early adopter of Bitcoin and Ethereum.</p>
          <a href="https://twitter.com/kennyrowe" target="_blank" rel="noopener" class="aragon underline blue text"><i class="ui twitter icon"></i>kennyrowe</a>
          <span style="display:inline-block; width: 1rem;"></span>
          <a href="https://github.com/kennyrowe" target="_blank" rel="noopener" class="aragon underline grey text"><i class="ui github icon"></i>kennyrowe</a>
        </div>
      </div>
      <div class="ui hidden divider"></div>
      <div class="ui hidden divider"></div>
      <div class="ui very relaxed very padded stackable grid">
        <div class="four wide column">
          <img class="ui middle aligned circular image" src="https://aragon.one/rsc/imgs/about/brayton.jpg">
        </div>
        <div class="twelve wide column">
          <h2>Brayton Williams - Founding Partner at Boost VC</h2>
          <p>Cofounder of <a target="_blank" href="https://boost.vc" rel="noopener">Boost VC</a>, an accelerator programme making sci-fi a reality and one of the top blockchain investors. They invested in Stampery — Luis' previous company — and were first in investing in Luis and Jorge's new venture, which ended up becoming Aragon.</p>
          <p>Brayton has spent his career in finance working with too-big-to-fail Morgan Stanley in wealth management and then to a FinTech startup selling private company securities. Then in 2012 he joined his co-worker, Adam Draper, to start Boost VC.</p>
          <a href="https://twitter.com/BraytonKey" target="_blank" rel="noopener" class="aragon underline blue text"><i class="ui twitter icon"></i>braytonkey</a>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'team',
}
</script>



// WEBPACK FOOTER //
// Team.vue?3001f85f